export const BREADCRUMB_CONTAINER_STYLES = ['flex', 'items-center', 'hidden', 'md:flex'].join(' ');

export const TEXT_COLOR = 'text-secondary-gray';

export const ICON_STYLE = ['w-4', 'h-4', 'mx-2'].join(' ');
